import { defineComponent, computed, openBlock, createElementBlock, createVNode, unref, createElementVNode, Fragment, createTextVNode, renderList, toDisplayString, withCtx, createBlock, createSlots, createCommentVNode } from "vue";
import { CdrButton, IconCheckLg } from "@rei/cedar";
import ClientOnly from "../ClientOnly/ClientOnly.mjs";
import IconJustForMembersBorder from "../Icons/IconJustForMembersBorder/IconJustForMembersBorder.mjs";
const _hoisted_1 = {
  class: "member-benefits"
};
const _hoisted_2 = {
  class: "member-benefits__subheading"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "member-benefits__list-scroller"
};
const _hoisted_5 = {
  class: "member-benefits__benefit-list",
  tabindex: "0",
  role: "group",
  "aria-label": "List of REI Co-op Membership Benefits"
};
const _hoisted_6 = {
  class: "member-benefits__benefit-card-image"
};
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = {
  class: "member-benefits__benefit-card-title"
};
const _hoisted_9 = {
  class: "member-benefits__benefit-card-body"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MemberBenefits",
  props: {
    subheading: {},
    buttons: {},
    sections: {},
    isMember: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    membershipAdded: {
      type: Boolean
    }
  },
  emits: ["addMembershipToCart", "metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const buttonText = computed(() => {
      if (props.loading) return "Adding to cart";
      return props.membershipAdded ? "Membership added to cart" : props.buttons.addMembership;
    });
    function handleExploreClick(event) {
      emit("metricsClick", {
        link: props.buttons.exploreMembership.target,
        linkName: "explore-membership",
        event
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(IconJustForMembersBorder), {
        class: "member-benefits__border member-benefits__border--top"
      }), createElementVNode("h3", _hoisted_2, [_ctx.subheading ? (openBlock(), createElementBlock("span", {
        key: 0,
        innerHTML: _ctx.subheading
      }, null, 8, _hoisted_3)) : (openBlock(), createElementBlock(Fragment, {
        key: 1
      }, [_cache[1] || (_cache[1] = createTextVNode(" A ")), _cache[2] || (_cache[2] = createElementVNode("span", {
        class: "member-benefits__subheading--italic"
      }, "lifetime", -1)), _cache[3] || (_cache[3] = createTextVNode(" of benefits "))], 64))]), createElementVNode("div", _hoisted_4, [createElementVNode("div", _hoisted_5, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.sections, (section) => {
        return openBlock(), createElementBlock("div", {
          key: section.heading,
          class: "member-benefits__benefit-card",
          "data-ui": "member-benefit-card"
        }, [createElementVNode("div", _hoisted_6, [createElementVNode("img", {
          src: section.image.src,
          alt: section.image.alt
        }, null, 8, _hoisted_7)]), createElementVNode("h4", _hoisted_8, toDisplayString(section.heading), 1), createElementVNode("div", _hoisted_9, toDisplayString(section.body), 1)]);
      }), 128))])]), createVNode(unref(ClientOnly), null, {
        default: withCtx(() => [!_ctx.isMember && _ctx.buttons.addMembership ? (openBlock(), createBlock(unref(CdrButton), {
          key: 0,
          modifier: _ctx.membershipAdded || _ctx.loading ? "secondary" : void 0,
          class: "member-benefits__button member-benefits__button--add-to-cart",
          "data-ui": "add-membership-to-cart",
          onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("addMembershipToCart", {}))
        }, createSlots({
          default: withCtx(() => [createTextVNode(toDisplayString(buttonText.value) + " ", 1)]),
          _: 2
        }, [_ctx.membershipAdded ? {
          name: "icon-left",
          fn: withCtx(() => [createVNode(unref(IconCheckLg), {
            "inherit-color": ""
          })]),
          key: "0"
        } : void 0]), 1032, ["modifier"])) : createCommentVNode("", true)]),
        _: 1
      }), _ctx.buttons.exploreMembership ? (openBlock(), createBlock(unref(CdrButton), {
        key: 0,
        class: "member-benefits__button member-benefits__button--explore",
        "data-ui": "explore-membership",
        modifier: "secondary",
        tag: "a",
        href: _ctx.buttons.exploreMembership.target,
        onClick: handleExploreClick
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.buttons.exploreMembership.text), 1)]),
        _: 1
      }, 8, ["href"])) : createCommentVNode("", true), createVNode(unref(IconJustForMembersBorder), {
        class: "member-benefits__border member-benefits__border--bottom"
      })]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=MemberBenefits2.mjs.map
